module.exports = __webpack_public_path__ + "static/media/icn_logout.ffabea77.svg";